var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.05,0c12.79-.29,24.35,10.79,23.94,24.68-.37,12.43-10.85,23.54-24.61,23.23C10.6,47.63-.4,36.8.01,23.14.39,10.44,11.22-.28,24.05,0ZM45.24,24c.16-11.59-9.49-21.06-20.72-21.31C12.52,2.41,2.94,12.24,2.73,23.47c-.22,11.75,9.18,21.47,20.74,21.73,12.33.28,21.87-9.84,21.76-21.2ZM24.34,38.23c4.14-.15,8.18-.8,12.07-2.31.77-.3,1.05-.69,1.01-1.51-.07-1.37-.06-2.75,0-4.12.07-1.84-.51-3.39-2.19-4.21-1.9-.93-3.94-1.53-5.99-.41-3.29,1.8-6.62,1.98-9.92.18-2.27-1.24-4.38-.72-6.47.26-1.46.69-2.1,2.04-2.14,3.62-.04,1.68-.05,3.37.02,5.04.02.36.37.89.71,1.04,3.71,1.68,7.62,2.46,11.68,2.42.41,0,.82.01,1.23,0ZM20.98,10.75c-4.26,2.32-5.26,8.43-2.04,12.09,2.34,2.66,5.74,3.22,8.61,1.32,2.08-1.37,3.08-3.42,3.36-5.86.49-4.3-2.82-8.31-6.95-8.52-1,.32-2.08.48-2.98.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.924c54361815715d73dec9c2c332afed.svg";
export { ForwardRef as ReactComponent };